import { useState } from "react";
import { Button, Modal, Tooltip, Tabs, Spin } from "antd";
import { BugOutlined } from "@ant-design/icons";
import { useApplicationContext } from "src/hooks/useApplication";
import { ExploreContext } from "pages/[orgId]/explore/useExploreContext";
import { useSubscribeEffect } from "src/hooks/useSubscribeEffect";
import { CSSProperties } from "react";

interface DebugButtonProps {
  context: ExploreContext;
  title?: string;
}

export function DebugButton({
  context,
  title = "Debug Data",
}: DebugButtonProps) {
  const app = useApplicationContext();
  const [isOpen, setIsOpen] = useState(false);

  // Subscribe to aggregations data
  useSubscribeEffect(context.aggregations);

  if (!app.isSuperAdmin) return null;

  const requestData = {
    params: context.params.state,
    doc: {
      title: context.doc.title,
      saved: context.doc.saved,
      initial: context.doc.initial,
    },
    view: {
      value: context.view.value,
      config: context.view.config,
    },
  };

  const preStyle: CSSProperties = {
    maxHeight: "70vh",
    overflow: "auto",
    userSelect: "text",
  };

  return (
    <>
      <Tooltip title="Debug Data">
        <Button
          size="small"
          shape="circle"
          type="text"
          onClick={() => setIsOpen(true)}
        >
          <BugOutlined />
        </Button>
      </Tooltip>
      <Modal
        title={title}
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width={800}
      >
        <Tabs
          items={[
            {
              key: "request",
              label: "Request Parameters",
              children: (
                <pre style={preStyle}>
                  {JSON.stringify(requestData, null, 2)}
                </pre>
              ),
            },
            {
              key: "response",
              label: "API Response",
              children: (
                <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                  {context.aggregations.isLoading ? (
                    <div style={{ textAlign: "center", padding: "20px" }}>
                      <Spin /> Loading...
                    </div>
                  ) : (
                    <pre style={preStyle}>
                      {JSON.stringify(
                        {
                          context: context,
                          data: context.aggregations.data,
                          error: context.aggregations.error,
                          entity: context.entity,
                          subquery: context.subquery.state,
                        },
                        null,
                        2
                      )}
                    </pre>
                  )}
                </div>
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
}
